module.exports = __webpack_public_path__ + "static/media/supply.fabd0920.svg";